export default {"src":"/_next/static/media/instacart.bc2e45e4.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};